'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import { useEffect, useState } from 'react';

/**
 * Whether the reader is pointing with a finger rather than a mouse.
 *
 * Starts fine so the server and the first client render agree, then corrects on
 * mount. Subscribed rather than read once, because a convertible reports a
 * different pointer when its keyboard is folded away.
 */
export const useCoarsePointer = (): boolean => {
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia('(pointer: coarse)');
    setCoarse(query.matches);
    const handleChange = (event: MediaQueryListEvent) => setCoarse(event.matches);
    query.addEventListener('change', handleChange);
    return () => query.removeEventListener('change', handleChange);
  }, []);

  return coarse;
};
